import type { ChatMessage } from "@/hooks/use-chat-messages";
import type { ChatRoomMemberInfo } from "@/hooks/use-chat-rooms";

/**
 * Per-melding lesebekreftelse: mapper hver melding-id til listen av andre
 * medlemmer som har last_read_at >= message.created_at OG hvor dette er
 * siste melding de har lest. Unngår å duplisere avatarer — hver bruker
 * vises bare én gang, på sin "nyeste leste melding".
 */
export function computeReceiptsByMessage(
  messages: ChatMessage[],
  members: ChatRoomMemberInfo[],
  currentUserId: string,
): Map<string, ChatRoomMemberInfo[]> {
  const receipts = new Map<string, ChatRoomMemberInfo[]>();
  for (const member of members) {
    if (member.user_id === currentUserId || !member.last_read_at) continue;
    const lastReadTs = new Date(member.last_read_at).getTime();
    let matchId: string | null = null;
    for (let i = messages.length - 1; i >= 0; i--) {
      if (new Date(messages[i].created_at).getTime() <= lastReadTs) {
        matchId = messages[i].id;
        break;
      }
    }
    if (matchId) {
      const arr = receipts.get(matchId) ?? [];
      arr.push(member);
      receipts.set(matchId, arr);
    }
  }
  return receipts;
}
